// Employee permissions organized by categories
// Synced with mobile app (nxsys-mobile/constants/common.ts)
export const ME_PERMISSION = {
  // Personal profile permissions
  PERSONAL_DETAILS_UPDATE: 'EMPLOYEE.ME.PERSONAL_DETAILS.UPDATE',
  CONTACT_DETAILS_UPDATE: 'EMPLOYEE.ME.CONTACT_DETAILS.UPDATE',
  ADDRESS_UPDATE: 'EMPLOYEE.ME.ADDRESS.UPDATE',
  BANK_DETAILS_UPDATE: 'EMPLOYEE.ME.BANK_DETAILS.UPDATE',
  HOLIDAY_PAY_DETAILS_SHOW: 'EMPLOYEE.ME.HOLIDAY_PAY_DETAILS.SHOW',

  // Work-related permissions
  TIMESHEETS_CREATE: 'EMPLOYEE.TIMESHEETS.CREATE',
  DOCUMENTS_CREATE: 'EMPLOYEE.DOCUMENTS.CREATE',
  EXPENSE_CREATE: 'EMPLOYEE.EXPENSE.CREATE',
} as const;

// Create a union type for type safety
export type MePermissionType =
  (typeof ME_PERMISSION)[keyof typeof ME_PERMISSION];
